export default {
	namespaced: true,
	state: {
		titulo: null,
		menuItems: [],
		topIcons: []
	},

	getters: {
		menu (state) {
			return state.menuItems
		},
		iconos (state) {
			return state.topIcons
		},
		titulo (state) {
			return state.titulo
		}
	},

	mutations: {
		setTitulo (state, payload) {
			state.titulo = payload
		},
		clearMenu (state) {
			state.menuItems = []
		},
		setMenu (state, payload) {
			window.setTimeout(() => {
				state.menuItems = payload
			}, 100)
		},
		addMenu (state, payload) {
			window.setTimeout(() => {
				state.menuItems.push(payload)
			}, 130)
		},
		delMenu (state, id) {
			state.menuItems = state.menuItems.filter(a => {
				return (a.id !== id)
			})
		},
		setMenuActivo (state, payload) {
			if (typeof payload === 'string') {
				payload = {
					nombre: payload
				}
			}
			state.menuItems = state.menuItems.map(menu => {
				menu.activo = (menu.nombre === payload.nombre)
				return menu
			})
		},
		setIcons (state, payload) {
			// El último icono siempre es la campana
			state.topIcons = payload
		}
	}
}



// WEBPACK FOOTER //
// ./src/modulos/core/vue/store/top.js